import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import { AssetContext } from './asset'

const PreviewCompatibleImage = ({ imageInfo, style = {} }) => {
  const imageStyle = { borderRadius: '5px', ...style }
  const { alt = '', childImageSharp, image } = imageInfo

  const getAsset = useContext(AssetContext)

  if (!!image && !!image.childImageSharp) {
    return (
      <Img style={imageStyle} fluid={image.childImageSharp.fluid} alt={alt} />
    )
  }

  if (!!childImageSharp) {
    return <Img style={imageStyle} fluid={childImageSharp.fluid} alt={alt} />
  }

  if (!!image && typeof image === 'string') {
    const src = getAsset(image)
    return <img style={imageStyle} src={src} alt={alt} />
  }

  return null
}

PreviewCompatibleImage.propTypes = {
  imageInfo: PropTypes.shape({
    alt: PropTypes.string,
    childImageSharp: PropTypes.object,
    image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    style: PropTypes.object,
  }).isRequired,
}

export default PreviewCompatibleImage
